import { React, useState } from "react";
import { useSpring, animated } from "react-spring";
import {MdExpandMore} from "react-icons/md";

function Accordion(props) {
  const [open, setOpen] = useState(false);
  
  //toggle accordion function
  let toggleHandler = (e) => {
    //switch state
    setOpen(!open);
  };

  //conditional styling
  const styles = {
    //if open is true, change color of title
    accordionTitle: {
      color: open ? "#f65000" : "#fff"
    }
  };
  // const styles1 = {
  //   //if open is true, change color of title
  //     text: {
  //     color: open ? "#f65000" : "#fff"
  //   }
  // };
  //open animation with react spring

  const openAnimation = useSpring({
    from: { opacity: "0", maxHeight: "25px" },
    to: { opacity: "1", maxHeight: open ? "200px" : "25px" },
    config: { duration: "300" }
  });

  //rotate animation
  const iconAnimation = useSpring({
    from: {
      transform: "rotate(0deg)",
      color: "#ffff"
    },
    to: {
      transform: open ? "rotate(180deg)" : "rotate(0deg)",
      color: open ? "#10d6f5" : "#fff"
    },
    config: { duration: "120" }
  });

  return (
    <animated.div className="accordion__item" style={openAnimation}>
      <div className="accordion__header" onClick={toggleHandler}>
        <h4 style={styles.accordionTitle}>{props.title}</h4>
        <animated.i style={iconAnimation}>
          <MdExpandMore/>
        </animated.i>
      </div>
      <p  onClick={toggleHandler} style={styles.text} className="accordion__content">{props.text}</p>
    </animated.div>
  );
}

export default Accordion;
